<template>
  <v-sheet class="mb-6">
    <template>
      <v-treeview
        :items="treeDocuments"
        dense
        expand-icon=""
        open-on-click
        transition
        return-object
      >
        <template slot="label" slot-scope="{ item }">
          <a class="js-tree-item" @click="showPreview(item)">{{ item.name }}</a>
        </template>
        <template v-slot:prepend="{ item, open }">
          <v-icon small color="secondary" v-if="item.children">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
        </template></v-treeview
      >
    </template>
    <v-overlay :value="overlay">
      <div class="d-flex justify-end">
        <v-btn icon @click="overlay = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card light max-width="850" min-width="500">
        <v-card-text>
          <div class="overline">document preview</div>

          <span v-if="allowEdit" class="doc-edit">
            <v-row>
              <v-col cols="2">name</v-col>
              <v-col>
                <v-text-field
                  outlined
                  single-line
                  dense
                  hide-details
                  id="js-document-name"
                  :value="document.name"
                  @blur="saveDocumentName"
                ></v-text-field>
              </v-col>
              <v-col cols="2"
                ><v-btn class="default-action-btn">save</v-btn></v-col
              >
            </v-row>
            <v-row v-if="allowFolders">
              <v-col cols="2">folder</v-col>
              <v-col>
                <v-text-field
                  outlined
                  single-line
                  dense
                  hide-details
                  id="js-document-folder"
                  :value="document.folder"
                  @blur="saveDocumentFolder"
                ></v-text-field>
              </v-col>
              <v-col cols="2"
                ><v-btn class="default-action-btn">save</v-btn></v-col
              >
            </v-row>
          </span>
          <div v-else class="subtitle-2">
            {{ document.name }}
          </div>
          <v-img
            class="mt-4 mb-4"
            max-width="750"
            max-height="500"
            contain
            v-if="isImage(document.url)"
            :src="document.url"
          ></v-img>
          <a :href="document.url" target="_blank" download="">Download</a>
          <nudges-list
            v-if="userMode == 'MENTOR'"
            class="my-4"
            :nudges="nudges"
            :menteeId="menteeUserId"
            :mentorId="loggedInUserId"
            nudgeableType="Document"
            :nudgeableId="document.id"
            :text="nudgeText(document)"
            v-on:nudge="refreshNudges"
          ></nudges-list>
        </v-card-text>
        <v-card-actions>
          <v-btn class="default-action-btn" @click="overlay = false">
            close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="allowDelete"
            class="dangerous-action-btn"
            @click="deleteDialog = true"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
    <v-dialog v-model="deleteDialog" persistent width="450">
      <v-card>
        <v-card-title class="headline">Document Delete</v-card-title>
        <v-card-text>
          <p>
            You have asked to delete
            <strong>{{ document ? document.name : "" }}</strong
            >.
          </p>
          <p>
            This action will permanently delete the document, as well as any
            mentee assignments.
          </p>
          <p>Select Delete if you understand and still want to procede.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="js-delete-confirm"
            class="dangerous-action-btn"
            @click="deleteItem(document.id)"
            >Delete</v-btn
          >
          <v-btn class="cancel-action-btn" @click="deleteDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import NudgesList from "@/components/NudgesList"

export default {
  mixins: [eventMixin],
  props: {
    documents: { type: Array, default: () => [] },
    allowDelete: { type: Boolean, default: false },
    allowEdit: { type: Boolean, default: false },
    allowFolders: { type: Boolean, default: true }
  },
  components: {
    NudgesList
  },
  data: function() {
    return {
      treeDocuments: [],
      overlay: false,
      deleteDialog: false,
      document: {}
    }
  },
  watch: {
    documents: function(newValue, oldValue) {
      this.putDocumentsInTree()
    }
  },
  created() {
    if (this.menteeUserId & (this.menteeUserId > 0)) {
      this.$store.dispatch("nudges/loadNudgesByMentee", this.menteeUserId)
    }
  },
  computed: {
    nudges() {
      let n = []

      if (this.document) {
        n = this.$store.getters["nudges/getNudgesByNudgeable"](
          "Document",
          this.document.id
        )
      }

      return n
    },
    userMode() {
      return this.$store.getters["globals/getUserMode"]
    },
    menteeUserId() {
      return this.$store.getters["globals/getMenteeId"]
    },
    loggedInUserId() {
      let user = this.$store.getters["users/getMe"]
      return user ? user.id : 0
    }
  },
  methods: {
    saveDocumentName(event) {
      this.fireEvent("tree:updateItem", {
        id: this.document.id,
        name: event.target.value
      })
      this.document.name = event.target.value
    },
    saveDocumentFolder(event) {
      this.fireEvent("tree:updateItem", {
        id: this.document.id,
        folder: event.target.value
      })
      this.document.folder = event.target.value
    },
    showPreview(doc) {
      if (!doc.children) {
        this.overlay = true
        this.document = doc
        console.log("in showPreview")
      }
    },
    isImage(url) {
      return (
        url &&
        (url.toUpperCase().includes(".JPG") ||
          url.toUpperCase().includes(".JPEG") ||
          url.toUpperCase().includes(".PNG") ||
          url.toUpperCase().includes(".SVG"))
      )
    },
    deleteItem(documentItem) {
      this.fireEvent("list:removeItem", documentItem)
      this.overlay = false
      this.deleteDialog = false
    },
    putDocumentsInTree() {
      this.treeDocuments.splice(0, this.treeDocuments.length)

      this.documents.forEach(document => {
        if (document.folder.length > 0) {
          let foundFolder = false
          this.treeDocuments.forEach(treeDocument => {
            if (treeDocument.children && treeDocument.name == document.folder) {
              foundFolder = true
              treeDocument.children.push(document)
            }
          })

          if (!foundFolder) {
            this.treeDocuments.push({
              name: document.folder,
              children: [document]
            })
          }
        } else {
          this.treeDocuments.push(document)
        }
      })

      this.treeDocuments = [...this.treeDocuments].sort((a, b) => {
        if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
        if (b.name.toUpperCase() > a.name.toUpperCase()) return -1

        return 0
      })
    },
    nudgeText(document) {
      return (
        "Document '" +
        document.name +
        "' available at " +
        window.location.origin +
        "/#/documents"
      )
    },
    refreshNudges() {
      this.$store.dispatch("nudges/loadNudgesByMentee", this.menteeUserId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";
</style>
